import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = ({ 
  title, 
  subtitle, 
  description, 
  primaryCTA, 
  secondaryCTA, 
  image,
  height = "min-h-[600px]"
}) => {
  return (
    <section className={`relative ${height} flex items-center overflow-hidden`}>
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={image} 
          alt="Hero background" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-primary/95 via-navy-primary/85 to-navy-primary/70"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl">
          {subtitle && (
            <div className="inline-block mb-4 px-4 py-2 bg-ice-blue/10 backdrop-blur-sm border border-ice-blue/20 rounded-full">
              <span className="text-ice-blue text-sm font-medium">{subtitle}</span>
            </div>
          )}
          
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {title}
          </h1>
          
          {description && (
            <p className="text-lg sm:text-xl text-white mb-8 leading-relaxed max-w-2xl">
              {description}
            </p>
          )}
          
          <div className="flex flex-col sm:flex-row gap-4">
            {primaryCTA && (
              <Link to={primaryCTA.link}>
                <Button 
                  size="lg" 
                  className="bg-white text-navy-primary hover:bg-ice-blue transition-all duration-300 shadow-lg hover:shadow-xl group"
                >
                  {primaryCTA.text}
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
                </Button>
              </Link>
            )}
            
            {secondaryCTA && (
              <Link to={secondaryCTA.link}>
                <Button 
                  size="lg" 
                  variant="outline" 
                  className="border-2 border-white text-white hover:bg-white hover:text-navy-primary transition-all duration-300"
                >
                  {secondaryCTA.text}
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>

      {/* Decorative Element */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
